import {ThemeProvider as MuiThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {ThemeProvider as BootStrapThemeProvider} from "react-bootstrap"
import {GympinTheme} from "./GympinTheme"
import {BrowserRouter} from "react-router-dom";
import rtlPlugin from 'stylis-plugin-rtl';
import {prefixer} from 'stylis';
import createCache from "@emotion/cache";
import "bootstrap/dist/css/bootstrap.rtl.min.css"
import "animate.css"
import "./style/style.css"
import GympinPagesProvider from "../components/GympinPagesProvider";
import GNotification from "./notification";
import React from "react";
import {useSelector} from "react-redux";
import {CacheProvider} from "@emotion/react";
import ApplicationRoutes from "./ApplicationRoutes";
import {FavoritesProvider} from "./FavoritesContext";

const {PUBLIC_URL} = process.env;

const rtlPluginFunc = rtlPlugin?.default || rtlPlugin;

// محافظت از پیشوندگذار استایلیس در برابر کرش‌های احتمالی ساختار AST
const safePrefixer = (element, index, children, callback) => {
    try {
        return prefixer(element, index, children, callback);
    } catch (_) {
        return '';
    }
};

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [safePrefixer, rtlPluginFunc],
});

function App() {
    const isAuthorized = useSelector(({auth: {user}}) => user ? user.Id != null : false);

    React.useEffect(() => {
        document.dir = "rtl";
        document.documentElement.dir = "rtl";
        document.documentElement.lang = "fa";
        if (document.body) {
            document.body.dir = "rtl";
        }
    }, []);

    return (

        <BrowserRouter basename={PUBLIC_URL}>
            <CacheProvider value={cacheRtl}>
                <MuiThemeProvider theme={GympinTheme}>
                    <CssBaseline />
                    <BootStrapThemeProvider dir="rtl">
                        <GympinPagesProvider>
                            <FavoritesProvider>
                                {isAuthorized &&
                                <GNotification/>
                                }
                                <ApplicationRoutes/>
                            </FavoritesProvider>
                        </GympinPagesProvider>
                    </BootStrapThemeProvider>
                </MuiThemeProvider>
            </CacheProvider>
        </BrowserRouter>
    )
}

export default App;
